module.exports = __webpack_public_path__ + "post-listing-block-6-image-step3-drSdByO.png";